export const menu = [
    {
      title: "文生文",
      img: "/assets/image/writing.png",
      selectimg: "/assets/image/writing-active.png",
      blackImg: "/assets/image/writing.png",
      router: "/web/writing",
      routerId: "5",
      isSelect: false,
      children: [],
    },
    {
      title: "文生图", 
      img: "/assets/image/txt.png",
      selectimg: "/assets/image/txt-active.png",
      blackImg: "/assets/image/txt.png",
      router: "/web/txt",
      routerId: "2",
      isSelect: false,
      children: [],
    },
    {
      title: "图生图", 
      img: "/assets/image/img.png",
      selectimg: "/assets/image/img-active.png",
      blackImg: "/assets/image/img.png",
      router: "/web/img",
      routerId: "3",
      isSelect: false,
      children: [],
    },
    {
      title: "文生视频",
      img: "/assets/image/video.png",
      selectimg: "/assets/image/video-active.png",
      blackImg: "/assets/image/video.png",
      router: "/web/t-video",
      routerId: "4",
      isSelect: false,
      children: [],
    },
    {
      title: "图生视频",
      img: "/assets/image/video.png",
      selectimg: "/assets/image/video-active.png",
      blackImg: "/assets/image/video.png",
      router: "/web/i-video",
      routerId: "9",
      isSelect: false,
      children: [],
    },
    {
      title: "模型", 
      img: "/assets/image/model.png",
      selectimg: "/assets/image/model-active.png",
      blackImg: "/assets/image/model.png",
      router: "/web/model",
      routerId: "6",
      isSelect: false,
      children: [],
    }, 
    // {
    //   title: "话术", 
    //   img: "/assets/image/wording.png",
    //   selectimg: "/assets/image/wording-active.png",
    //   blackImg: "/assets/image/wording.png",
    //   router: "/web/wording",
    //   routerId: "7",
    //   isSelect: false,
    //   children: [],
    // },
    // {
    //   title: "素材库",
    //   img: "/assets/image/material.png",
    //   selectimg: "/assets/image/material-active.png",
    //   blackImg: "/assets/image/material.png",
    //   router: "/web/material",
    //   routerId: "8",
    //   isSelect: false,
    //   children: [],
    // },
]